export const AuthSealRouting = [
  {
    path: "/organization/auth-seal/list",
    name: "organization-auth-seal-list",
    meta: { title: "印章授权" },
    component: () =>
      import(
        /* webpackChunkName: "basic-organization-auth-seal" */ "@/views/organization/auth-seal/list/index.vue"
      ),
  },
];
